<div nz-form [nzLayout]="'vertical'" [formGroup]="stepForm">
  <h3>{{ "COMPONENTS.APPLY_PLAN.TITLE" | translate }}</h3>

  <div class="spacer"></div>

  <div nz-row nzGutter="16">
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzFor="billToAccount">
          {{ "COMPONENTS.APPLY_PLAN.FORM.BILL_TO_ACCOUNT.LABEL" | translate }}
        </nz-form-label>

        <nz-form-control>
          <nz-select
            id="billToAccountId"
            [nzPlaceHolder]="
              'COMPONENTS.APPLY_PLAN.FORM.BILL_TO_ACCOUNT.PLACEHOLDER'
                | translate
            "
            formControlName="billToAccountId"
          >
            <nz-option
              [nzLabel]="'GLOBAL_TERMS.DEFAULT' | translate"
              [nzValue]="'DEFAULT'"
            ></nz-option>
            <nz-option
              *ngFor="let billToAccount of billToAccountsList"
              [nzLabel]="billToAccount.name"
              [nzValue]="billToAccount.billToAccountId"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label nzFor="temp_transactionReason">
          {{
            "COMPONENTS.APPLY_PLAN.FORM.TRANSACTION_REASON.LABEL" | translate
          }}&nbsp;<span class="hint"
            >({{ "FORM.LABEL.OPTIONAL" | translate }})</span
          >
        </nz-form-label>

        <nz-form-control>
          <nz-select
            id="temp_transactionReason"
            nzAllowClear
            [nzPlaceHolder]="
              'COMPONENTS.APPLY_PLAN.FORM.TRANSACTION_REASON.PLACEHOLDER'
                | translate
            "
            formControlName="temp_transactionReason"
          >
            <nz-option
              *ngFor="let transactionReason of transactionReasons"
              [nzLabel]="
                'GLOBAL_TERMS.TRANSACTION_REASON.' + transactionReason
                  | translate
              "
              [nzValue]="transactionReason"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item
        *ngIf="
          stepForm.get('temp_transactionReason')?.value ===
          TransactionReason.OTHER
        "
      >
        <nz-form-label nzFor="memo">
          {{ "COMPONENTS.APPLY_PLAN.FORM.MEMO.LABEL" | translate }}&nbsp;<span
            class="hint"
            >({{ "FORM.LABEL.OPTIONAL" | translate }})</span
          >
        </nz-form-label>

        <nz-form-control>
          <textarea
            nz-input
            id="memo"
            [rows]="DefaultConst.TEXTAREA_ROWS"
            [placeholder]="
              'COMPONENTS.APPLY_PLAN.FORM.MEMO.PLACEHOLDER' | translate
            "
            formControlName="memo"
          ></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <div *ngIf="isCustomizablePlan" formGroupName="temp_plan">
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="duration">
            {{ "FORM.LABEL.DURATION" | translate }}
          </nz-form-label>

          <nz-form-control>
            <div nz-row nzGutter="8" nzAlign="middle">
              <div nz-col nzSpan="8">
                <nz-input-number
                  [nzMin]="durationMin"
                  [nzMax]="durationMax"
                  [nzPrecision]="0"
                  [nzPlaceHolder]="
                    'COMPONENTS.APPLY_PLAN.FORM.DURATION.PLACEHOLDER'
                      | translate
                  "
                  formControlName="duration"
                ></nz-input-number>
              </div>
              <div nz-col>
                {{ "DATE_TIME.DAYS" | translate }}
              </div>
            </div>
            <div nz-row>
              <div nz-col>
                <span class="hint">
                  {{ "COMPONENTS.APPLY_PLAN.FORM.DURATION.HINT" | translate }}
                </span>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="capacity">
            {{ "FORM.LABEL.CAPACITY" | translate }}
          </nz-form-label>

          <nz-form-control>
            <div nz-row nzGutter="8" nzAlign="middle">
              <div nz-col nzSpan="8">
                <nz-input-number
                  [nzMin]="capacityMin"
                  [nzMax]="capacityMax"
                  [nzPrecision]="2"
                  [nzPlaceHolder]="
                    'COMPONENTS.APPLY_PLAN.FORM.CAPACITY.PLACEHOLDER'
                      | translate
                  "
                  formControlName="capacity"
                ></nz-input-number>
              </div>
              <div nz-col nzSpan="4">
                <nz-select formControlName="temp_capacityUnit">
                  <nz-option
                    *ngFor="let unit of byteUnits"
                    [nzLabel]="unit"
                    [nzValue]="unit"
                  ></nz-option>
                </nz-select>
              </div>
            </div>
            <div nz-row>
              <div nz-col>
                <span class="hint">
                  {{ "COMPONENTS.APPLY_PLAN.FORM.CAPACITY.HINT" | translate }}
                </span>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <nz-form-item formGroupName="voice">
          <nz-form-label nzFor="initial">
            {{ "FORM.LABEL.VOICE_CAPACITY" | translate }}
          </nz-form-label>

          <nz-form-control>
            <div nz-row nzGutter="8" nzAlign="middle">
              <div nz-col nzSpan="8">
                <nz-input-number
                  [nzMin]="voiceSmsMin"
                  [nzMax]="voiceSmsMax"
                  [nzPrecision]="0"
                  [nzPlaceHolder]="
                    'COMPONENTS.APPLY_PLAN.FORM.VOICE_CAPACITY.PLACEHOLDER'
                      | translate
                  "
                  formControlName="initial"
                ></nz-input-number>
              </div>
              <div nz-col>
                {{ "DATE_TIME.MINUTES" | translate }}
              </div>
            </div>
            <div nz-row>
              <div nz-col>
                <span class="hint">
                  {{
                    "COMPONENTS.APPLY_PLAN.FORM.VOICE_CAPACITY.HINT" | translate
                  }}
                </span>
              </div>
            </div>
            <div nz-row nzGutter="8">
              <div nz-col>
                <label nz-checkbox formControlName="unlimited" ngDefaultControl>
                  <span
                    [innerHTML]="'FORM.LABEL.MARKET_AS_UNLIMITED' | translate"
                  ></span>
                </label>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="12">
        <nz-form-item formGroupName="sms">
          <nz-form-label nzFor="initial">
            {{ "FORM.LABEL.SMS" | translate }}
          </nz-form-label>

          <nz-form-control>
            <div nz-row nzGutter="8" nzAlign="middle">
              <div nz-col nzSpan="8">
                <nz-input-number
                  [nzMin]="voiceSmsMin"
                  [nzMax]="voiceSmsMax"
                  [nzPrecision]="0"
                  [nzPlaceHolder]="
                    'COMPONENTS.APPLY_PLAN.FORM.SMS_CAPACITY.PLACEHOLDER'
                      | translate
                  "
                  formControlName="initial"
                ></nz-input-number>
              </div>
              <div nz-col>
                {{ "FORM.LABEL.SMS" | translate }}
              </div>
            </div>
            <div nz-row nzGutter="8">
              <div nz-col>
                <span class="hint">
                  {{
                    "COMPONENTS.APPLY_PLAN.FORM.SMS_CAPACITY.HINT" | translate
                  }}
                </span>
              </div>
            </div>
            <div nz-row>
              <div nz-col>
                <label nz-checkbox formControlName="unlimited" ngDefaultControl>
                  <span
                    [innerHTML]="'FORM.LABEL.MARKET_AS_UNLIMITED' | translate"
                  ></span>
                </label>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="listPrice">
            {{ "FORM.LABEL.LIST_PRICE" | translate }}
          </nz-form-label>

          <nz-form-control>
            <input
              nz-input
              nzBorderless
              [placeholder]="
                multiStepForm.formData?.listPrice
                  ? (multiStepForm.formData?.listPrice
                      | utils: 'convertToDollars') +
                    ' ' +
                    ('CURRENCY.MXN' | translate)
                  : '--'
              "
              readonly
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="finalPrice">
            {{ "FORM.LABEL.FINAL_PRICE" | translate }}
          </nz-form-label>

          <nz-form-control>
            <div nz-row nzGutter="8" nzAlign="middle">
              <div nz-col nzSpan="8">
                <nz-input-number
                  [nzMin]="finalPriceMin"
                  [nzMax]="finalPriceMax"
                  [nzPrecision]="2"
                  [nzPlaceHolder]="
                    'COMPONENTS.APPLY_PLAN.FORM.FINAL_PRICE.PLACEHOLDER'
                      | translate
                  "
                  formControlName="finalPrice"
                ></nz-input-number>
              </div>
              <div nz-col>
                {{ "CURRENCY.MXN" | translate }}
              </div>
            </div>
            <div nz-row>
              <div nz-col>
                <span class="hint">
                  {{
                    "COMPONENTS.APPLY_PLAN.FORM.FINAL_PRICE.HINT" | translate
                  }}
                </span>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </div>
</div>
